import React, { memo } from "react";
import styled from "@emotion/styled";

interface DropdownOption {
  value: string | number;
  label: string;
}

interface DropdownProps {
  id: string;
  label?: string;
  options: DropdownOption[];
  selectedValue: string | number;
  onChange: (value: any) => void;
  disabled?: boolean;
}

// Define styled components using Emotion
const DropdownContainer = styled.div``;

const DropdownLabel = styled.label`
  color: #1a1a1a;
  text-align: left;
  font-weight: bold;
`;

const DropdownSelect = styled.select`
  color: #1a1a1a;
  text-align: left;
  border: 1px solid #cccccc;
  width: 100%;
  font-size: 14px;

  &:focus {
    border: 1px solid #5c5c5c;
  }
`;

const StyledDropdownOption = styled.option`
  background: #ffffff 0% 0% no-repeat padding-box;
`;

export const Dropdown = memo(function Dropdown({
  id,
  label,
  options,
  selectedValue,
  onChange,
  disabled = false,
}: DropdownProps) {
  // Handle change event
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = event.target.value;
    onChange(newValue);
  };

  return (
    <DropdownContainer>
      <DropdownLabel htmlFor={id}>{label}</DropdownLabel>
      <DropdownSelect
        id={id}
        value={selectedValue}
        disabled={disabled}
        onChange={handleChange}
      >
        {options.map((option) => (
          <StyledDropdownOption key={option.value} value={option.value}>
            {option.label}
          </StyledDropdownOption>
        ))}
      </DropdownSelect>
    </DropdownContainer>
  );
});
